export default [
  {
    path: '/',
    name: 'layout',
    redirect: '/home',
    component: () => import('@views/layout'),
    children: [
      {
        path: '/home',
        name: 'home',
        meta: {
          title: '首页'
        },
        component: () => import('@views/home')
      }, {
        path: '/search',
        name: 'search',
        meta: {
          title: '查档申请',
          parent: 'home'
        },
        component: () => import('@views/search')
      }, {
        path: '/search-mobile',
        name: 'search-mobile',
        meta: {
          title: '查档申请-移动端'
        },
        component: () => import('@views/search-mobile')
      }, {
        path: '/reservation',
        name: 'reservation',
        meta: {
          title: '预约查档',
          type: 1,
          parent: 'search'
        },
        component: () => import('@views/reservation')
      }, {
        path: '/online',
        name: 'online',
        meta: {
          title: '在线查档',
          type: 2,
          parent: 'search'
        },
        component: () => import('@views/reservation')
      }, {
        path: '/modify-register',
        name: 'modify-register',
        meta: {
          title: '修改查档信息登记',
          parent: 'modify-search',
          query: true
        },
        component: () => import('@views/modify-register')
      }, {
        path: '/record',
        name: 'record',
        meta: {
          title: '查档记录',
          parent: 'home'
        },
        component: () => import('@views/record')
      }, {
        path: '/modify-search',
        name: 'modify-search',
        meta: {
          title: '查档申请',
          parent: 'record',
          query: true
        },
        component: () => import('@views/modify-search')
      }, {
        path: '/information',
        name: 'information',
        meta: {
          title: '详情信息',
          parent: 'record'
        },
        component: () => import('@views/information')
      }, {
        path: '/news',
        name: 'news',
        meta: {
          title: '新闻列表'
        },
        component: () => import('@views/news')
      }, {
        path: '/content',
        name: 'content',
        meta: {
          title: '新闻内容'
        },
        component: () => import('@views/content')
      }
    ]
  }
]
